import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};


import * as filterCounter from './scripts/filter-counter';
filterCounter.init();

import * as imageGallerySlider from './scripts/image-gallery-slider';
imageGallerySlider.init();

import * as teaserSliderLg from './scripts/teaser-slider-lg';
teaserSliderLg.init();

import * as genericSlider from './scripts/generic-slider';
genericSlider.init();